export const AccountData = {
    id: "",
    username: "",
    salt: null, // Uint8Array or Buffer for byte[]
    saltedAndHashedPassword: null, // Uint8Array or Buffer for byte[]
    facebookUserId: "",
    googleUserId: "",
    microsoftUserId: "",
    twitterUserId: "",
    appleUserId: "",
    appleRefreshToken: "",
    app: 0,
    isDeleted: false,
    createdAt: null, // Date or ISO string
    deleted: false,
    updatedAt: null, // Date or ISO string
    version: null, // Uint8Array or Buffer for byte[]
    lastLoggedIn: null, // Date or ISO string
    lastLoggedInIP: "",
    nbOfFailedAttempts: 0,
    saltHistory: "[]", // JSON array of salts as string
    saltedAndHashedPasswordHistory: "[]", // JSON array of passwords as string
    lastLoginAttempt: null // Date or ISO string
};